import React, { useState } from "react";

const Temp = () => {
  const [formData, setFormData] = useState({
    name: "",
   // email: "",
    education: "",
   // experience: "",
    imageUrl: "",
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;",
      è: "&egrave;",
      ê: "&ecirc;",
      à: "&agrave;",
      ç: "&ccedil;",
      î: "&icirc;",
      ï: "&iuml;",
      ô: "&ocirc;",
      ù: "&ugrave;",
      û: "&ucirc;",
    };
    return text.replace(/[\u00E0-\u00FC]/g, (char) => replacements[char] || char);
  };

  const saveAsHtmlFile = async () => {
    const { name, email, education, experience, imageUrl } = formData;

    const safeName = replaceFrenchCharacters(name);
   // const safeEmail = replaceFrenchCharacters(email);
    const safeEducation = replaceFrenchCharacters(education);
    //const safeExperience = replaceFrenchCharacters(experience);

    const cvHtml = `
     <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title>${safeName}</title>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta name="format-detection" content="telephone=no"/>
<meta name="x-apple-disable-message-reformatting" content=""/>
<!-- Proof 2><!-->
<!--[if !mso]><!-->
<link type="text/css" href="https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700" rel="stylesheet"  />
<link type="text/css" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
<!--<![endif]-->

<style type="text/css">
	
a[href^="x-apple-data-detectors:"] { color: inherit; text-decoration: inherit; }
.appleLinks a {color:#000000; text-decoration: none;}
.appleLinksWhite a {color:#ffffff; text-decoration: none;}
.samsungLinks a {color:#666666; text-decoration: none;}		

body {
	margin: 0 auto !important; 
	padding: 0 !important;
	-webkit-text-size-adjust: 100% !important;
	-ms-text-size-adjust: 100% !important;
	-webkit-font-smoothing: antialiased !important;
}
img {
	border: 0 !important;
	outline: none !important;
}
p {
	Margin: 0px !important;
	Padding: 0px !important;
}
table {
	border-collapse: collapse;
	mso-table-lspace: 0px;
	mso-table-rspace: 0px;
}
td, a, span {
	border-collapse: collapse;
	mso-line-height-rule: exactly;
}
.ExternalClass * {
	line-height: 100%;
}
.em_defaultlink a {
	color: inherit !important;
	text-decoration: none !important;
}
span.MsoHyperlink {
	mso-style-priority: 99;
	color: inherit;
}
span.MsoHyperlinkFollowed {
	mso-style-priority: 99;
	color: inherit;
}
input {
	display: none !important;
}
	
/* CSS for hiding content in desktop/webmail clients */
.imghide {
  max-height: 0px;
  font-size: 0;
  display: none;
  overflow: hidden;
}
	
 @media only screen and (min-width:481px) and (max-width:549px) {
	.desk-visible {
	display: none;
	}
 	.showmenu {
    display:block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height:inherit !important;
    max-width:inherit !important;
    line-height: normal !important;
    margin-top:0px !important;
    visibility:inherit !important;
    border-bottom: 0 !important;
   }
 	*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
   }
 	*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size:23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
   }
 	*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
   }
 	*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
   }
  .em_main_table {
    width: 100% !important;
  }
  .em_wrapper {
    width: 100% !important;
  }
  .em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    font-size: 20px !important;
    border-top: 1px solid #ffffff;
  }
  .em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    font-size: 20px !important;
  }
  .em_side {
    width: 10px !important;
  }
  .em_hide {
    width: 100% !important;
    height: auto !important;
  }
  .em_img {
    width: 100% !important;
    height: auto !important;
  }
  .em_center {
    text-align: center !important;
  }
  .em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
  }
  .em_pad {
    padding-top: 20px !important;
  }
  .em_aside {
    padding: 0 10px !important;
  }
  .em_topbom {
    padding: 20px 0px !important;
  }
  div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
  }
  .em_f60 {
   	font-size: 70px !important;
	line-height: 72px !important;
   }
  .em_f40 {
    font-size: 42px !important;
    line-height: 42px !important;
   }
  .em_h10 {
    height: 10px !important;
  }
  .em_h40 {
    height: 40px !important;
  }
  .em_h30 {
    height: 30px !important;
  }
  .em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
  }
  .em_hide1 {
    display: none !important;
  }
  .em_max375 {
    max-width: 375px !important;
  }

}
@media screen and (max-width: 480px) {
	.desk-visible {
	display: none;
	}
	.showmenu {
    display:block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height:inherit !important;
    max-width:inherit !important;
    line-height: normal !important;
    margin-top:0px !important;
    visibility:inherit !important;
    border-bottom: 0 !important;
  }
	*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
  }
	*[id]#nav_handle {
    background:url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
	*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat; 
  }
	*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
  }
  .em_main_table {
    width: 100% !important;
  }
  .em_wrapper {
    width: 100% !important;
  }
  .em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    border-top: 1px solid #ffffff;
    font-size: 20px !important;
  }
  .em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 40px !important;
    font-size: 20px !important;
  }
  .em_side {
    width: 10px !important;
  }
  .em_hide {
    display: none !important;
  }
  .em_img {
    width: 100% !important;
    height: auto !important;
  }
  .em_center {
    text-align: center !important;
  }
  .em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
  }
  .em_pad {
    padding-top: 20px !important;
  }
  .em_aside {
    padding: 0 10px !important;
  }
  u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important;
  }
  .em_topbom {
    padding: 20px 0px !important;
  }
  div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
  }
  .em_f60 {
	font-size: 55px !important;
	line-height: 58px !important;
  }
  .em_f40 {
    font-size: 34px !important;
    line-height: 34px !important;
  }
  .em_h10 {
    height: 10px !important;
  }
  .em_h40 {
    height: 40px !important;
  }
  .em_h30 {
    height: 30px !important;
  }
  .em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
  }
  .em_hide1 {
    display: none !important;
  }
  .em_font12 {
    font-size: 10px !important;
    line-height: 14px !important;
  }
  .em_max375 {
    max-width: 375px !important;
  }

  .imghide {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
  }
  *[class].width414 {
    width:414px !important;
  }
  *[class].heightAuto {
    height: auto !important;
  }
}

@media screen and (max-width: 414px) {
  .desk-visible {
	display: none;
	}
	.imghide414 {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
  }
  .em_hide414 {
    display: none !important;
  }
  .em_br414 {
    display: block !important;
    padding: 0 0 5px 0 !important;
  }
  .borders{
	  border-left:2px  #333 ;
  }
}
</style>
<!--[if gte mso 9]><xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml><![endif]-->
</head>

<body class="em_body" style="margin:0px; padding:0px;" bgcolor="#ffffff">
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
  <tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        
        <!-- A03 HEADER SECTION -->
        <tr>
          <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
              <tr>
                <td align="center" valign="top" bgcolor="#000000" style="padding:0 10px;"><table width="530" border="0" cellspacing="0" cellpadding="0" align="center" style="width:530px;" class="em_wrapper">
                    
                    <!-- HEADER SECTION -->
                    <tr>
                      <td  style="PADDING-BOTTOM: 22px; PADDING-TOP: 5px; PADDING-LEFT: 0px; PADDING-RIGHT: 0px" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                          <tbody>
                            <!-- PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" style="padding:4px 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top" style="font-family: 'Arial', sans-serif; font-size:11px; line-height:14px; color:#ffffff;">${safeEducation}</td>
                                  </tr>
                                </table></td>
                            </tr>
                            <!-- //PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" class="em_topbom" style="padding:24px 0 0 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top"><a href="https://www.grainger.ca?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
" style="text-decoration:none;"><img src="http://t.e1.acklands.grainger.com/res/img/636B14955A5D8DC77E329D8A3E628C65.gif" width="230" height="80" alt="logo" title="logo" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#ffffff; font-weight:bold; max-width:230px;" /></a></td>
                                  </tr>
                                </table></td>
                            </tr>
                          </tbody>
                        </table></td>
                    </tr>
                    
                    <!-- //HEADER SECTION -->
                    
                  </table></td>
              </tr>
              
              <!-- NAVIGATION MENU -->
              <tr>
                <td bgcolor="#2a333b" valign="top" align="center"><table class="em_wrapper" style="TABLE-LAYOUT: fixed" cellspacing="0" cellpadding="0" width="550" align="center" border="0">
                    <tbody>
                      <tr>
                        <td valign="middle" align="center"><!--[if !mso]><!-->
                          
                          <input id="em_drop" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none !important; LINE-HEIGHT: 0; MAX-HEIGHT: 0px" type="checkbox"/>
                          <div class="showmenu" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none; LINE-HEIGHT: 0; MAX-HEIGHT: 0px">
                            <table style="MARGIN: 0px auto" cellspacing="0" cellpadding="0" align="center" border="0">
                              <tbody>
                                <tr>
                                  <td height="50" valign="middle" align="center"><label id="nav_handle" for="em_drop"></label></td>
                                  <td style="WIDTH: 10px" width="10">&nbsp;</td>
                                  <td style="FONT-SIZE: 20px; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff" height="50" valign="middle" align="center"><label for="em_drop">MENU</label></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          
                          <!--<![endif]-->
                          
                          <div id="nav_menu" style="MARGIN-LEFT: 0px; Z-INDEX: 50; MARGIN-RIGHT: 0px"><!--<![endif]--><!--[if gte mso 9]>
	  <table width="550" border="0" cellspacing="0" cellpadding="0" align="left" class="em_wrapper">
	  <tr>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--><a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; TEXT-TRANSFORM: uppercase; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
"><span 
			class="em_hide">&nbsp; </span>MY ACCOUNT</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/category/c/1?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">ALL PRODUCTS</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/orderHistory&cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">ORDER 
                            HISTORY</a><!--[if gte mso 9]>
	  </td>
	  <td height="50" valign="middle" align="center">
	  <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 100px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/cart?from=%2Ffr%2Fcat%25C3%25A9gorie%2Fc%2F1%3Fanalytics%3Dnav%26aType%3Dbrc&cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">CART<span 
			class="em_hide">&nbsp;</span></a><!--[if gte mso 9]>
	  </td>
	  </tr>
	  </table>
	  <![endif]--> 
                          </div></td>
                      </tr>
                    </tbody>
                  </table></td>
              </tr>
              <!-- //NAVIGATION MENU -->
            </table></td>
        </tr>
      </table></td>
  </tr>
  <!-- //C04 SECONDARY SECTION -->
  
  <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td><a href="https://www.grainger.ca/en?cm_mmc=${imageUrl}"><img src="3-D copy.jpg" alt="hero" width="550" height="330" style="font-family: 'Arial', sans-serif; font-size: 22px; width: 550px; color: #000000; display: block;" title="hero" border="0"/></a></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
<tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        
        <!-- F01 SOCIAL SECTION -->
        <tbody>
          <tr>
            <td 
          style="PADDING-BOTTOM: 25px; PADDING-TOP: 25px; PADDING-LEFT: 10px; PADDING-RIGHT: 10px" 
          bgcolor="#2a333b" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                <tbody>
                  <tr>
                    <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.facebook.com/graingercanada?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="facebook" 
                  src="http://t.e1.acklands.grainger.com/res/img/BBD24EC070059605A9645A5DFE160806.png" 
                  width="45" height="45"/></a></td>
                    <td style="WIDTH: 20px" width="20">&nbsp;</td>
                    <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.youtube.com/graingercanada?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="youtube" 
                  src="http://t.e1.acklands.grainger.com/res/img/2894A2E9B556F7DB16FF117A20426EE1.png" 
                  width="45" height="45"/></a></td>
                    <td style="WIDTH: 20px" width="20">&nbsp;</td>
                    <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.linkedin.com/company/graingercanada?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="linkedin" 
                  src="http://t.e1.acklands.grainger.com/res/img/7A31981414EDAE346169F26E55381B00.png" 
                  width="45" height="45"/></a></td>
                  </tr>
                </tbody>
              </table></td>
          </tr>
          <!-- //F01 SOCIAL SECTION --> 
          
          <!-- F02 FOOTER SECTION -->
          <tr>
            <td 
          style="PADDING-BOTTOM: 0px; PADDING-TOP: 0px; PADDING-LEFT: 30px; PADDING-RIGHT: 30px" 
          bgcolor="#000000" valign="top" align="center"><table class="em_wrapper" style="WIDTH: 490px" cellspacing="0" 
            cellpadding="0" width="490" align="center" border="0">
                <tbody>
                  <tr>
                    <td class="em_defaultlink em_pad" 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 38px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="center"><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">My Account</a><span 
                  class="em_br414"></span><span class="em_hide414"> &nbsp;|&nbsp; </span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/contact-us?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">Contact 
                      Us</a> &nbsp;|&nbsp;<span></span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/find-branch-location?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">Find a Branch</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/policies/privacy-policy?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">Privacy 
                      Policy</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/emailSignUp/unsubscribe?email=<%=recipient.email%>&cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
">Unsubscribe</a></td>
                  </tr>
                  <tr>
                    <td 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 15px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="left"><p><br />
                        <font color="#ffffff">This email was sent to email <a style="TEXT-DECORATION: none; COLOR: #ffffff" href="../2nd Dec  Winter Preparedness - Private Brands/$clickthrough(#)$">&lt;%= recipient.email %&gt;</a></font>.<br />
                        <br />
                        To ensure delivery to your inbox, add <a href="mailto:grainger@b.grainger.ca" target="_top" style="color: #ffffff !important; text-decoration:none !important;"><font color="#ffffff">grainger@b.grainger.ca</font></a> to your address&nbsp;book. <br />
                        <br />
                        <a href="https://www.grainger.ca/en/content/contact-us?cm_mmc=EMP-_-Brand-_-HappyHolidays-_-16Dec24-_-EN
" style="text-decoration: underline; color: inherit !important;"><font color="#ffffff">Questions</font></a>? Our Customer Service Centre is here to help you manage your orders, update&nbsp;an existing order, and place new ones.<br />
                        <br />
                        Acklands-Grainger Inc. “Grainger” “Grainger Canada” is a distributor of MRO products to businesses, and such products are to be used for business purposes only. We reserve the&nbsp;right to restrict sales of products unless business verification has been performed.<br />
                        <br />
                        Grainger Canada 123 Commerce Valley Drive East, Suite 700, Thornhill, Ontario&nbsp;L3T&nbsp;7W8</p></td>
                  </tr>
                  <tr>
                    <td style="HEIGHT: 40px" 
          height="40">&nbsp;</td>
                  </tr>
                </tbody>
              </table></td>
          </tr>
          <!-- //F02 FOOTER SECTION -->
          <tr>
            <td class="em_hide" style="line-height:1px;min-width:550px;background-color:#ffffff;"><img alt="" src="http://t.e1.acklands.grainger.com/res/img/F2229E22CDA170C551671E5853235FE1.gif" height="1"  width="550" style="max-height:1px; min-height:1px; display:block; width:550px; min-width:550px;" border="0" /></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
</body>
</html>
    `;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: "Generated_CV.html",
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        alert("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "Generated_CV.html";
        link.click();
        URL.revokeObjectURL(link.href);
        alert("File downloaded successfully!");
      }
    } catch (error) {
      console.error("Error saving file:", error);
    }
  };

  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: "20px", backgroundColor: "#f4f4f9" }}>
      <h1 style={{ textAlign: "center" }}>CV Maker with Image</h1>
      <form
        onSubmit={handleFormSubmit}
        style={{
          maxWidth: "500px",
          margin: "0 auto",
          padding: "20px",
          background: "#fff",
          borderRadius: "8px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <label style={{ fontWeight: "bold" }}>Full Name:</label>
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleInputChange}
          placeholder="Enter your name"
          required
        />
        <label style={{ fontWeight: "bold" }}>Sl Name:</label>
        <input
          type="text"
          name="education"
          value={formData.education}
          onChange={handleInputChange}
          placeholder="Enter your Sl"
          required
        />

        <label style={{ fontWeight: "bold" }}>Image URL:</label>
        <input
          type="text"
          name="imageUrl"
          value={formData.imageUrl}
          onChange={handleInputChange}
          placeholder="Enter image URL"
          
        />

        <button
          type="submit"
          style={{
            width: "100%",
            margin: "10px 0",
            padding: "10px",
            background: "#007bff",
            color: "#fff",
            fontWeight: "bold",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Generate CV
        </button>
      </form>

      {showPreview && (
        <div
          style={{
            margin: "20px auto",
            maxWidth: "600px",
            background: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2 style={{ textAlign: "center" }}>CV Preview</h2>
          <img
            src={formData.imageUrl}
            alt={`${formData.name}'s Image`}
            style={{ maxWidth: "100%", height: "auto", display: "block", marginBottom: "10px" }}
          />
          <p>
            <strong>Name:</strong> {formData.name}
          </p>
          <p>
            <strong>Email:</strong> {formData.email}
          </p>
          <h3>Education</h3>
          <p>{formData.education}</p>
          <h3>Experience</h3>
          <p>{formData.experience}</p>
          <button
            onClick={saveAsHtmlFile}
            style={{
              width: "100%",
              margin: "10px 0",
              padding: "10px",
              background: "#28a745",
              color: "#fff",
              fontWeight: "bold",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Save as HTML
          </button>
        </div>
      )}
    </div>
  );
};

export default Temp;
